import { render, staticRenderFns } from "./veJkyPaperCount.vue?vue&type=template&id=05b5d4da&scoped=true"
import script from "./veJkyPaperCount.vue?vue&type=script&lang=js"
export * from "./veJkyPaperCount.vue?vue&type=script&lang=js"
import style0 from "./veJkyPaperCount.vue?vue&type=style&index=0&id=05b5d4da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b5d4da",
  null
  
)

export default component.exports